import styled from "styled-components";
import { size } from "styled-theme";
import { mobileBreakPoint } from "./constants";
import LogoImageLoanOptionsLogo from "@theme/assets/loan-options-logo.png";
import React from "react";

const LoanOptionsLogoWrapper = styled.div`
  padding-top: 5px;

  .logo-image {
    max-height: 40px;
  }
  @media only screen and (max-width: ${size(mobileBreakPoint)}) {
    .logo-image {
      max-height: 40px;
    }
  }
`;

export const LoanOptionsLogo = () => (
  <LoanOptionsLogoWrapper>
    <img className="logo-image" src={LogoImageLoanOptionsLogo} alt="logo" />
  </LoanOptionsLogoWrapper>
);